import { IOrderFrequency, isSingletonFrequency } from '../../types/order';
import {
    renderBaseInterval,
    renderRecurrenceUnit,
    renderRecurrenceUnitAdverb,
    renderRecurrenceUnitCompact,
} from '../../types/recurrence';

export function renderOrderFrequencyOnceTwiceStyle({
    frequency,
    withIntervals,
}: {
    frequency: IOrderFrequency;
    withIntervals: boolean;
}) {
    if (isSingletonFrequency(frequency)) {
        return 'Once';
    }
    const { numVisitsPerInterval, intervalCount, intervalUnit } = frequency;
    let label = '';
    switch (numVisitsPerInterval) {
        case 1:
            label = `Once ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
        case 2:
            label = `Twice ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
        default:
            label = `${numVisitsPerInterval}x ${renderRecurrenceUnitAdverb(intervalUnit)}`;
            break;
    }
    if (withIntervals) {
        label += ` for ${intervalCount} ${renderRecurrenceUnit(intervalUnit, intervalCount)}`;
    }
    return label;
}

export function renderOrderFrequency1xStyle({
    frequency,
    withIntervals,
}: {
    frequency: IOrderFrequency;
    withIntervals: boolean;
}) {
    const { numVisitsPerInterval, intervalCount, intervalUnit } = frequency;
    let label = `${numVisitsPerInterval}x ${renderRecurrenceUnitAdverb(intervalUnit)}`;

    if (withIntervals) {
        label += ` for ${intervalCount} ${renderBaseInterval(intervalUnit, intervalCount)}`;
    }

    return label.toLowerCase();
}

// The shorthand form, for places too narrow for a sentence: "2w3" reads as twice weekly for
// three weeks. The unit always shows, because "2d3" and "2m3" are equally valid orders.
export function renderOrderFrequencyCompact({ frequency }: { frequency: IOrderFrequency }) {
    const { numVisitsPerInterval, intervalCount, intervalUnit } = frequency;

    return `${numVisitsPerInterval}${renderRecurrenceUnitCompact(intervalUnit)}${intervalCount}`;
}

export function renderOrderMinMaxActiveOccurrences({
    numActiveOccurrences,
    maxActiveOccurrences,
    minActiveOccurrences,
}: {
    numActiveOccurrences: number;
    maxActiveOccurrences: number;
    minActiveOccurrences: number;
}) {
    if (minActiveOccurrences === maxActiveOccurrences) {
        return `${numActiveOccurrences} / ${minActiveOccurrences} visits`;
    }
    return `${numActiveOccurrences} / ${minActiveOccurrences} - ${maxActiveOccurrences} visits`;
}
